import React from "react";
import {
  Box,
  PinInput,
  PinInputField,
  HStack,
  Button,
  Flex,
} from "@chakra-ui/react";
import {
  primary,
  primaryAlt,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";

const PinCodeInputs = ({
  length,
  onComplete,
  onVerify,
  pinCode,
  setPinCode,
}) => {
  const { t } = useTranslation();

  const handleChange = (val) => {
    // Prevent typing more than needed
    if (val.length <= length) {
      setPinCode(val);

      if (val.length === length) {
        onComplete(val);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (pinCode.length === length) {
      onVerify(pinCode);
    }
  };

  return (
    <Box w="100%" mb={6}>
      <form style={{ width: "100%" }} onSubmit={handleSubmit}>
        <HStack justify="flex-start" w="100%">
          <PinInput
            color={textSecondary}
            placeholder=""
            onChange={handleChange}
            onComplete={onComplete}
          >
            {Array.from({ length }).map((_, index) => (
              <PinInputField
                color={textPrimary}
                fontWeight="500"
                borderRadius="1rem"
                fontSize="1.5rem"
                h="4rem"
                w="100%"
                key={index}
                autoFocus={index === 0}
                _focus={{
                  border: `1px solid ${primary}`,
                  boxShadow: "none !important",
                }}
              />
            ))}
          </PinInput>
        </HStack>
        <Flex
          w="100%"
          align="center"
          justify="center"
          maxW={["100%", "300px"]}
          m="2rem auto 0"
        >
          <Button
            type="submit"
            bg={textPrimary}
            color={white}
            fontWeight="500"
            size="lg"
            fontSize="md"
            h="3.5rem"
            borderRadius="10rem"
            w="100%"
            onClick={onVerify}
            isDisabled={pinCode.length !== 4}
            _hover={{
              bg: primaryAlt,
            }}
          >
            {t("patient.patientPortalVerifyPin")}
          </Button>
        </Flex>
      </form>
    </Box>
  );
};

export default PinCodeInputs;
